<template>
	<v-autocomplete
		v-model="returnValue"
		v-model:search="search"
		:items="items"
		:loading="isLoading"
		hide-no-data
		hide-selected
		item-title="label"
		:label="label"
		placeholder="Start typing to Search"
		return-object
		:disabled="!this.editable"
	></v-autocomplete>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
	computed: {
		...mapState({
			token: "token",
		}),
	},
	props: {
		defaultValue: Object,
		editable: {
			type: Boolean,
			default: true,
		},
		label: String,
	},
	data: () => {
		return {
			isLoading: false,
			search: "",
			returnValue: null,
			items: [],
		};
	},
	watch: {
		search(val) {
			if (this.isLoading) return;

			this.isLoading = true;
			console.log(this.token);

			axios
				.get(process.env.VUE_APP_BACKEND_URL + "/plane/getPlane?term=" + val, {
					headers: { Authorization: "bearer " + this.token },
				})
				.then((response) => {
					this.items = response.data;
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		returnValue(val) {
			this.$emit("returnValue", val);
		},
	},
	created() {
		if (this.defaultValue) {
			this.returnValue = this.defaultValue;
		}
	},
};
</script>

<style></style>
